import { IReactSelectOptionObject } from "../types";

export const reactSelectNoneOption: IReactSelectOptionObject<string | undefined> = {
    value: undefined,
    label: "none".localize(),
};
